import { cartApi, getTranslation, updateCart } from '../helpers';

const selectors = {
  addToCartButton: '[data-add-to-cart-item]',
  addToCartText: '[data-add-to-cart-text]',
};

const BUTTON_RESET_DELAY = 2000; // milliseconds

export default class DynamicFeaturedProduct {
  constructor(section) {
    this.el = section.el;
    this.originalButtonText = null;

    this.init();
  }

  init() {
    this._initAddToCart();
  }

  /**
   * Initialize add to cart functionality
   */
  _initAddToCart() {
    const button = this.el.querySelector(selectors.addToCartButton);

    if (!button) {
      return;
    }

    // Store the original button text (including price) for later restoration
    const textElement = button.querySelector(selectors.addToCartText);
    if (textElement) {
      this.originalButtonText = textElement.textContent.trim();
    }

    button.addEventListener('click', this._onAddToCart);
  }

  /**
   * Handle add to cart button click
   */
  _onAddToCart = e => {
    e.preventDefault();
    const button = e.currentTarget;
    const variantId = button.dataset.variantId;

    if (!variantId || button.disabled) {
      return;
    }

    this._toggleLoading(button, true, getTranslation('products.adding'));

    cartApi
      .add({
        items: [
          {
            id: parseInt(variantId, 10),
            quantity: 1,
          },
        ],
      })
      .then(response => {
        this._toggleLoading(button, false, getTranslation('products.added'));

        if (response.sections) {
          updateCart({ sections: response.sections, openCart: true });
        }

        // Reset button text after a short delay
        setTimeout(() => {
          if (button && !button.disabled && this.originalButtonText) {
            button.querySelector(selectors.addToCartText).textContent =
              this.originalButtonText;
          }
        }, BUTTON_RESET_DELAY);
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.error(error);
        this._toggleLoading(button, false, getTranslation('products.error'));

        // Reset button text after error
        setTimeout(() => {
          if (button && !button.disabled && this.originalButtonText) {
            button.querySelector(selectors.addToCartText).textContent =
              this.originalButtonText;
          }
        }, BUTTON_RESET_DELAY);
      });
  };

  /**
   * Toggle loading state of add to cart button
   */
  _toggleLoading(button, isLoading, text) {
    if (!button) {
      return;
    }

    button.disabled = isLoading;
    if (text) {
      button.querySelector(selectors.addToCartText).textContent = text;
    }
  }

  /**
   * Clean up event listeners
   */
  onSectionUnload() {
    const button = this.el.querySelector(selectors.addToCartButton);
    if (button) {
      button.removeEventListener('click', this._onAddToCart);
    }
  }
}
